module.exports = __webpack_public_path__ + "media/la.3d67b0ec.mp4";